import type { LinkHeroDto } from '@hcr/api/optimizely'
import type { Link } from '@hcr/ui'

export const createLinkHero = (dto: LinkHeroDto): Link => ({
  isExternal: true,
  label: dto.label,
  to: dto.url,
})
